import { render } from "./CompanyDetailsNav.vue?vue&type=template&id=6d0481d0"
import script from "./CompanyDetailsNav.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__